@import '~style-sheet-helpers/core.less';
@import '../../../../../app-brand/entities/entity-layer.module.less';
@import '../../../../../constants/spacing.module.less';

.button-display {
  > * {
    font-size: 12px;
    line-height: 16px;
    padding: @space-4 @space-8;
    min-width: 50px;
    height: 34px;
    border-radius: 4px;
    border: 1px solid var(--gray-AFB3B6);
    background-color: var(--grey-000);

    &:disabled {
      border: 1px solid var(--gray-DFE4E8);
    }
  }

  display: flex;
  flex-wrap: wrap;
  gap: 8px;

  .icon {
    margin-top: 3px;
    height: 20px;
    width: 19px;
    padding-left: 3px;
    color: var(--primary--icon--fill-color--2);
    vertical-align: top;
  }
  .button-background {
    background-color: var(--button-light--background-color);
  }
}

.modal-title {
  font-size: 16px;
}

.modal-body {
  padding: 16px;
  background-color: var(--modal--background-color);
}

.body-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.title {
  font-size: 16px;
  color: var(--default--text-color--17);
}

.amount {
  text-align: right;
  font-size: 20px;
  color: var(--default--text-color--17);
}

.currency-funds {
  height: 48px;
  width: 388px;
  font-size: 24px;
  input {
    font-size: 24px;
  }
}

.input-margin {
  margin-top: 7px;
}
.amount-note-text {
  font-size: 12px;
  margin-top: 5px;
  margin-bottom: 8px;
  color: var(--default--text-color--15);

  .hint {
    color: var(--default--border-color--8);
  }
}

.amount-error {
  background-color: var(--inline-message--error--background-color);
  height: 24px;
  margin-top: 1px;
  display: flex;
  align-items: center;
}

.error-icon {
  margin-right: 4px;
  color: var(--inline-message--error--text-color);
  height: 16px;
  width: 16px;
  margin-left: 3px;
}

.note-text {
  font-size: 12px;
  margin-top: 10px;
  margin-bottom: 8px;

  .hint {
    color: var(--default--border-color--8);
  }
}

.modal-footer-background {
  background-color: var(--modal--footer--background-color-2);
}

.funds-summary {
  margin-top: @space-16;
}

.other-button {
  height: auto;
  padding: 0;
  min-width: auto;
  border: none;
  box-shadow: none;
  background-color: transparent;
}
.amount-button-selected {
  background-color: var(--blue-600);
  color: var(--grey-000);
  border: 1px solid var(--blue-600);
  outline: none;
}
